
import translations from '../lang';
import React from 'react';
import TimelineItem from '../components/TimelineItem';


function Home({ lang }) {




  return (
    <>
    <section className="about-section">
      <div className="about-container">
        <div className="about-photo">
          <img src="assets/img/1.png" alt="Profile" />
        </div>
        <div className="about-text">
          <h2>{translations.aboutTitle[lang]}</h2>
          {translations.aboutText[lang].map((para, index) => (
            <p key={index}>{para}</p>
            ))}
        </div>
      </div>
    </section>
 
   <section className="timeline-section">
      <h2 className="timeline-title">{translations.timelineTitle[lang]}</h2>
            <div className="timeline">

            {/*<TimelineItem
              title={lang === 'zh' ? '红外自动计数装置 2022.6' : 'Infrared Automatic Counter---Jun.,2022'}
              content={translations.timelineContent.first[lang]}
            />*/}

            {/*<TimelineItem
            title={lang === 'zh' ? '迷宫寻路 2022.9' : 'Maze Navigation---Sep.,2022'}
            content={translations.timelineContent.second[lang]}
            />*/}

            {/*<TimelineItem
            title={lang ===  'zh' ? '温度测量与控制系统 2023.2' : 'Temperature Measurement and Control System---Feb.,2023'}
            content={translations.timelineContent.third[lang]}
            />*/}
            
            {/*<TimelineItem
            title={lang === 'zh' ? '晶圆检测工程师 2022.6-2022.8' : 'Chip Probing Engineer---Jun.-Aug.,2022'}
            content={translations.timelineContent.eighth[lang]}
            targetHash="#exp-wafer-probe-2022" 
            />*/}

            <TimelineItem
            title={lang === 'zh' ? '技术支持工程师 2023.7-2023.8' : 'Technical Support Engineer---Jul.-Aug.,2023'}
            content={translations.timelineContent.fourth[lang]}
            targetHash="#exp-tech-support-2023" 
            />

            <TimelineItem
            title={lang ===  'zh' ? '嵌入式软件工程师 2023.9-2023.11' : 'Embed System Software Engineer---Sep.-Nov.,2023'}
            content={translations.timelineContent.fifth[lang]}
            targetHash="#exp-embedded-dev-2023"
            />

            <TimelineItem
            title={lang ===  'zh' ? '技术与系统统筹工程师 2025.9-2026.2' : 'Technology & System Coordinator---Sep.,2025-Feb.,2026'}
            content={translations.timelineContent.nineth[lang]}
            targetHash="#exp-vosyn-internship-2025"
            />

            {/*<TimelineItem
            title={lang ===  'zh' ? '声纹识别系统 2024.1-2024.5' : 'Speaker Recognition---Jan.-May.,2024'}
            content={translations.timelineContent.sixth[lang]}
            />*/}

           {/*<TimelineItem
            title={lang ===  'zh' ? '嵌入式软件工程师 2024.6-2024.8' : 'Embed System Software Engineer---Jun.-Aug.,2024'}
            content={translations.timelineContent.seventh[lang]}
            targetHash="#exp-embedded-dev-2024"
            />*/}



            </div>

    </section>


     
   </> 
  );
}

export default Home;